import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import SaleFooter from '../SaleFooter/SaleFooter';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../../provider/providerManager';

import {
  goToPage, reportAnalytics, setIsSubmit, setIsValid, setError, addSelectedPhone, addTotalPriceOneTime, currentTotalPriceOneTime, setPrettyNumChosenCount,
  setRegularNumChosenCount, setPrettyNumChosenReset, setRegularNumChosenReset
} from '../saleBlockSlice';
import { initData } from '../ChoseNewOrExistingCellNum/ChoseNewOrExistingCellNumSlice';
import { initDataCellularServices } from '../ChooseCellularServices/ChooseCellularServicesSlice';
import ChoseNewOrExistingCellNum from '../ChoseNewOrExistingCellNum/ChoseNewOrExistingCellNum';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';

const ChooseNumberPage = (props) => {
  let flowType = props.flowType;
  const [existPhoneMessage, setExistPhoneMessage] = useState('');

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    props.reportAnalytics({
      eventCategory: 'cellular_newsale_process',
      eventAction: flowType == 'existsCustomer' ? 'visibility_5' : 'visibility_16',
      eventLabel: eventLabel,
    });
  }, []);

  //page params
  let isDisplayFooter = props._choseNewOrExistingCellNum.isSelectedOption;
  let btnText = 'בואו נמשיך';
  let currentPageFunction = handleChooseNumberContinue;
  let totalPrice = props.totalPrice;
  let totalPriceOneTime = props.totalPriceOneTime;
  let priceText = 'לחודש';
  let formid = 'sale';
  //page params

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      props.initData({ form: props._choseNewOrExistingCellNum });
      props.initDataCellularServices();
    }
  }, []);


  let title = null;
  let subTitle = '';
  let firstName = props._authentication.loginData.userDetails.firstName;
  let titleText = props.selectedPhoneIndex == 0 ? `איך ברצונך להתקדם?` : `נמשיך בבחירת מספר ${props.selectedPhoneIndex + 1}`;

  if (flowType == 'existsCustomer') {
    title = (
      <span>
        היי {firstName}, <br /> {titleText}
      </span>
    );
    subTitle = 'לפני שמתחילים, חשוב לנו לדעת:';
  } else {
    title = titleText;
    subTitle = 'לפני שמתחילים, חשוב לנו לדעת:';
  }

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> {title} </h1>
    </div>
  );

  let currentPageView = (
    <ChoseNewOrExistingCellNum
      flowType={props.flowType}
      selectedProducts={props.productsInfo.selectedProducts}
      selectedPhoneIndex={props.productsInfo.selectedPhoneIndex}
      onValid={handleChooseNumberValidate}
      onSubmit={props.isSubmit}
      onError={handleOnError}
      existPhoneMessage={existPhoneMessage}
      prettyNumbersUnderBtnText={props.productsInfo.baseProduct.prettyNumberUnderBtnText}
      prettyNumberPrice={props.productsInfo.baseProduct.prettyNumberPrice}
      totalPriceOneTime={props.totalPriceOneTime}
      currentTotalPriceOneTime={(item) => props.currentTotalPriceOneTime(item)}
      addTotalPriceOneTime={(item) => props.addTotalPriceOneTime(item)}
      setPrettyNumChosenCount={(num) => props.setPrettyNumChosenCount(num)}
      setRegularNumChosenCount={(num) => props.setRegularNumChosenCount(num)}
      setPrettyNumChosenReset={(num) => props.setPrettyNumChosenReset(num)}
      setRegularNumChosenReset={(num) => props.setRegularNumChosenReset(num)}
      PrettyNumChosenCount={props.PrettyNumChosenCount}
      RegularNumChosenCount={props.RegularNumChosenCount}
      numbersCount={{
        regularNumbersCount: props.productsInfo.baseProduct.regularNumbersCount,
        prettyNumbersCount: props.productsInfo.baseProduct.prettyNumbersCount,
      }}
    />
  );

  function handleChooseNumberContinue() {
    props.setIsSubmit({ isSubmit: true });
  }

  function handleChooseNumberValidate(valid) {
    if (!valid) props.setIsSubmit({ isSubmit: false });

    if (valid) {
      handleChooseNumberContinueAfterValid();
    }
  }

  async function handleChooseNumberContinueAfterValid() {
    const isExistPhone = props._choseNewOrExistingCellNum.isExistPhone;
    const existPhone = props._choseNewOrExistingCellNum.currentPhone;
    const newPhone = isExistPhone ? props._choseNewOrExistingCellNum.hstPhone : props._choseNewOrExistingCellNum.selectedPhone;
    const productMakat = props.productsInfo.baseProduct?.productMakat;
    let prettyPhoneData = {};

    if (props._choseNewOrExistingCellNum.isPrettyNum) {
      prettyPhoneData.isPrettyPhone = props._choseNewOrExistingCellNum.isPrettyNum;
      prettyPhoneData.prettyNumbersSOC = props.productsInfo.baseProduct.pettyNumberDiscountSOC;
      prettyPhoneData.prettyNumbersName = props.productsInfo.baseProduct.prettyNumberName;
      prettyPhoneData.prettyNumbersPrice = props.productsInfo.baseProduct.prettyNumberPrice;
    }

    if (isExistPhone) {
      props.reportAnalytics({
        eventCategory: 'cellular_newsale_process',
        eventAction: flowType == 'existsCustomer' ? 'click_11' : 'click_32',
        eventLabel: productMakat,
      });
    } else {
      props.reportAnalytics({
        eventCategory: 'cellular_newsale_process',
        eventAction: flowType == 'existsCustomer' ? 'click_13' : 'click_34',
        eventLabel: productMakat,
      });
    }

    if (isExistPhone) {
      const isAvailable = await getEntityDetailsInfo(existPhone);
      if (!isAvailable) {
        setExistPhoneMessage(`המנוי הזה כבר חלק מהמשפחה. אנחנו רואים שהמספר הזה כבר שייך ל${window.Config.brand_Name_HE}, כדאי לבדוק שזה המספר הנכון ולנסות שוב`);
        props.setIsSubmit({ isSubmit: false });
        return;
      }
    }

    props.setIsSubmit({ isSubmit: false });

    let filteredVasList = props.productsInfo.baseProduct.vasList?.filter((x) => !x.isVirtualSoc);
    const hasVasList = filteredVasList != null && filteredVasList.length > 0;
    const allowEsimProccess = props.esim?.allowEsimProcess != undefined ? props.esim?.allowEsimProcess : false;

    props.addSelectedPhone({
      isExistPhone: isExistPhone,
      existPhone: existPhone,
      newPhone: newPhone,
      prettyPhoneData: prettyPhoneData,
    });


    const nextPage = getNextPage(hasVasList, allowEsimProccess);


    if (flowType == 'existsCustomer') {
      props.goToPage({ page: nextPage, percent: 28 });
    } else {
      props.goToPage({ page: nextPage, percent: 20 });
    }
  }

  const getNextPage = (hasVasList, allowEsimProccess) => {
    let nextPage = "";
    if (allowEsimProccess && props.flowType == 'existsCustomer') {
      nextPage = "chooseTypeSIM";
    }
    else if (hasVasList) {
      nextPage = "extraPage";
    }
    else {
      nextPage = "newNumberPage";
    }
    return nextPage;
  };

  //1225
  async function getEntityDetailsInfo(subscriberNo) {
    props.showAppLoader();
    try {
      console.info('getEntityDetailsInfo:', 'subscriberNo:' + subscriberNo);

      const result = await ProviderManager.getProviderData('getEntityDetailsInfo', [subscriberNo]);
      console.info('getEntityDetailsInfo', result);

      const isAvailable = result.Body.isSuccess && result.Body.phoneOperatorName != 'CELL';
      return isAvailable;
    } catch (error) {
      console.info(error);
      props.setError({ isDisplay: true, id: 30 });
      return null;
    } finally {
      props.hideAppLoader();
    }
  }

  function handleOnError(errorId) {
    props.setError({ isDisplay: true, id: errorId, isOpenWorkOrder: true });
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          totalPriceOneTime={totalPriceOneTime}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    totalPriceOneTime: state.saleBlock.totalPriceOneTime,
    isSubmit: state.saleBlock.isSubmit,
    isValid: state.saleBlock.isValid,
    productsInfo: state.saleBlock.productsInfo,
    esim: state.saleBlock.esim,
    PrettyNumChosenCount: state.saleBlock.PrettyNumChosenCount,
    RegularNumChosenCount: state.saleBlock.RegularNumChosenCount,
    //other states
    _choseNewOrExistingCellNum: state.choseNewOrExistingCellNum.form,
    _authentication: state.authentication,
    currentNumber: state.saleBlock.currentNumber,
    selectedPhoneIndex: state.saleBlock.productsInfo.selectedPhoneIndex
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setError,
  addSelectedPhone,
  addTotalPriceOneTime,
  currentTotalPriceOneTime,
  setPrettyNumChosenCount,
  setRegularNumChosenCount,
  setPrettyNumChosenReset,
  setRegularNumChosenReset,
  //other states
  initData,
  initDataCellularServices,

  //loader
  showAppLoader,
  hideAppLoader,

};

export default connect(mapStateToProps, mapDispatchToProps)(ChooseNumberPage);
